import { Avatar as AntdAvatar, type AvatarProps } from 'antd'
import styles from './styles.module.scss'

export function Avatar({ className, ...props }: AvatarProps) {
  return <AntdAvatar className={[className, styles.avatar].join(' ')} {...props} />
}
